import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/eventRecord',
    meta: { title: '事件管理' },
    component: Layout,
    redirect: '/eventRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '事件管理', activeMenu: '/eventRecord' },
        component: () => import('@/views/eventRecord/EventRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '事件详情', activeMenu: '/eventRecord' },
        component: () => import('@/views/eventRecord/EventRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增事件', activeMenu: '/eventRecord' },
        component: () => import('@/views/eventRecord/EventRecordAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑事件', activeMenu: '/eventRecord' },
        component: () => import('@/views/eventRecord/EventRecordAdd.vue')
      },
      {
        path: 'addRecord',
        meta: { title: '新增事件记录', activeMenu: '/eventRecord' },
        component: () => import('@/views/eventRecord/EventRecordListAdd.vue')
      }

    ]
  }

]
